import { fetchGetSelectPaymentProcessorByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../iwQueryClient/useStateKey';

export function usePaymentProcessor() {
    const stateKey = useStateKey();

    const {
        data: paymentProcessor,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['fetchGetSelectPaymentProcessor', stateKey],
        queryFn: () => fetchGetSelectPaymentProcessorByStateKey({ stateKey }),
        select: (data) => data?.data.payment_processor
    });

    return { paymentProcessor, isLoading, isError };
}
